<!DOCTYPE html>
<div class="flyout-wrapper" #wrapper>
  <div class="flyout-content">
    <ng-lottie
      class="flyout-lottie"
      [options]="lottieOptions"
      [styles]="{ width: '100%', height: '100%' }"
      (animationCreated)="onLottieCreated($event)"
    ></ng-lottie>
  </div>
</div>
